// TODO - code duplication with comments.js


  angular.module('clientDashboardApp.common').directive('note', Notes);

  function Notes() {

    return {
      restrict: 'A',
      template: function (tElement, tAttrs) {
        if (tAttrs.templateType === 'table') {
          return require('./notesWrapper.html')
        } else {
          return require('./notes.html')
        }
      },
      scope: {
        rowItem: "=",
        noteSettings: '=',
        provider: '='
      },
      controller: NotesController,
      controllerAs: 'vm',
      link: (scope, elem, attrs) => {
        scope.thisElem = elem
      }
    }
  }

  function NotesController($scope, $rootScope, $timeout, confirmService, noteService) {

    var vm = this;

    $scope.assetUrl = $rootScope.assetUrl;

    vm.notes = {
      notesForm: {},
      isSelectedRow: false,
      selectedRowId: null,
      tempNotesArray: null,
      showNotes: true,
      editNote: false,
      updating: false,
      showVisibilityCheckbox: false,
      tempNoteAddDetail: null,
      defaultVisibilitySetting: "Standard",
      defaultVisibilityChecked: false,
      deleteTarget: {
        entity: null,
        note: null
      },
      tempNoteEditPristine: {},
      tempNoteEdit: null,
      tempNoteAdd: {
        entityId: "",
        noteType: "",
        dateAdded: "",
        lastUpdated: "",
        userId: "",
        userName: "",
        firstName: "",
        lastName: "",
        visibility: "Standard",
        noteDetail: ""
      }
    };

    vm.colspan = "1";

    vm.activeDeleteNoteRow = null;

    vm.visibilityOptions = [
      {
        id: "Admin",
        name: "Admin"
      },
      {
        id: "Standard",
        name: "All"
      }
    ];


    vm.notes.isAdmin = () => $scope.noteSettings.userInfo.permissions.indexOf('NoteAdmin') >= 0;

    $scope.$watch('noteSettings.newNote', function (newVal, oldVal) {
      if (newVal === true && $scope.noteSettings.newNoteItem[$scope.noteSettings.idKey] === $scope.rowItem[$scope.noteSettings.idKey]) {
        vm.newNote();
        $scope.noteSettings.newNote = false;
      }
    }, 1)


    vm.hasVisibleNotes = (notes) => (notes.reduce((acc,el) => {return acc || vm.noteVisible(el)}, false))

    vm.noteVisible = function (note) {
      return ($scope.noteSettings.userInfo.permissions.indexOf('NoteAdmin') >= 0 && note.visibility === "Admin") || note.visibility === "Standard";
    }

    vm.initDefaultVisibilitySettings = function () {
      $scope.$watch('noteSettings.userInfo', function (newVal, oldVal) {
        if (newVal !== oldVal) {
          if ($scope.noteSettings.userInfo.defaultNoteVisibilityLevel) {
            vm.notes.defaultVisibilitySetting = $scope.noteSettings.userInfo.defaultNoteVisibilityLevel;
            vm.notes.tempNoteAdd.visibility = vm.notes.defaultVisibilitySetting;
          }
        }
      })
    }

    vm.initDefaultVisibilitySettings();

    vm.refreshDefaultVisibilitySettings = function () {
      if ($scope.noteSettings.userInfo.defaultNoteVisibilityLevel) {
        vm.notes.defaultVisibilitySetting = $scope.noteSettings.userInfo.defaultNoteVisibilityLevel;
      }
    }

    vm.newNote = function () {
      vm.hideVisibilityCheckbox();
      vm.initDefaultVisibilitySettings();
      vm.notes.isSelectedRow = true;
      vm.notes.editNote = true;
      vm.notes.tempNoteAdd.noteDetail = null;
      vm.notes.notesForm.$pristine = true;
      vm.notes.notesForm.$dirty = false;
      $($scope.thisElem).find('.cm-note-new textarea').focus();
    }

    vm.cancelNewNote = function () {
      $scope.rowItem.newNote = false;
      vm.notes.editNote = false;
    }

    vm.editNote = function (rowItem, note, event) {

      var height = angular.element('#cm-note-' + note._id + ' .cm-note-detail').height();
      if (height <= 20) {
        height = 20;
      }
      angular.element('#cm-note-' + note._id + ' textarea.cm-note-detail').css({height: height});

      if (vm.notes.tempNoteEdit != null) {
        vm.notes.tempNoteEdit.editing = false;
        vm.notes.tempNoteEdit.noteDetail = noteService.processAsHtml(vm.notes.tempNoteEditPristine.noteDetail);
      }

      vm.notes.selectedRowId = rowItem.id;
      note.editing = true;
      angular.copy(note, vm.notes.tempNoteEditPristine);
      vm.notes.tempNoteEdit = note;
      vm.notes.tempNoteEditPristine.noteDetail = noteService.processFromHtml(vm.notes.tempNoteEditPristine.noteDetail);
      vm.notes.tempNoteEdit.noteDetail = noteService.processFromHtml(vm.notes.tempNoteEdit.noteDetail);
      $timeout(function () {
        $($scope.thisElem).find('#cm-note-' + note._id + ' textarea').focus();
      });
    };


    vm.cancelEditNote = function () {
      if (vm.notes.tempNoteEdit != null) {
        vm.notes.tempNoteEdit.editing = false;
        vm.notes.tempNoteEdit.noteDetail = noteService.processAsHtml(vm.notes.tempNoteEditPristine.noteDetail);
      }
    };


    vm.deleteNote = function (entity, note, $event) {
      noteService.setDeleteTarget(entity, note);
      vm.activeDeleteNoteRow = "#cm-note-" + note._id;
      confirmService.confirm(
        'Are you sure you want to delete this Note?',
        'Once the note is deleted you cannot recover it.',
        confirmService.WARNING
      ).then(confirmedDelete => {
        if (confirmedDelete) {
          noteService.deleteNote(note._id).then(function () {
            vm.reloadNotes(entity, $scope.noteSettings.noteType);
            noteService.resetDeleteTarget();
          });
        }
      })
    }

    vm.reloadNotes = function (entity, type) {
      var idArray = [entity[$scope.noteSettings.idKey]];
      noteService.getNotes(idArray, type).then(function (data) {
        entity.notes = data;
        _.each(entity.notes, function (e) {
          e.noteDetail = noteService.processAsHtml(e.noteDetail);
        });
      });
    }

    vm.updateNote = function (entity, note) {
      note.noteDetail = noteService.processAsHtml(note.noteDetail);
      vm.noteUpdateRequest = angular.copy(note);
      vm.noteUpdateRequest.noteDetail = noteService.processFromHtml(vm.noteUpdateRequest.noteDetail);
      vm.notes.tempNoteEdit = null;
      delete note.editing;
      noteService.updateNote(vm.noteUpdateRequest).then(function () {
        vm.reloadNotes(entity, $scope.noteSettings.noteType);
      });
    };

    vm.canEdit = function (note) {
      return $scope.noteSettings.userInfo.userId === note.userId || vm.notes.isAdmin();
    };

    vm.saveNote = function (rowItem) {
      vm.notes.updating = true;
      var addNoteRequest = {};

      angular.copy(vm.notes.tempNoteAdd, addNoteRequest);
      addNoteRequest.noteType = $scope.noteSettings.noteType;
      addNoteRequest.entityId = rowItem[$scope.noteSettings.idKey];
      addNoteRequest.userId = $scope.noteSettings.userInfo.userId;
      addNoteRequest.firstName = $scope.noteSettings.userInfo.firstName;
      addNoteRequest.lastName = $scope.noteSettings.userInfo.lastName;
      addNoteRequest.userName = $scope.noteSettings.userInfo.username;
      addNoteRequest.noteDetail = noteService.stripHtml(addNoteRequest.noteDetail);

      noteService.addNote(addNoteRequest).then(function () {
        vm.reloadNotes(rowItem, $scope.noteSettings.noteType);
        vm.notes.editNote = false;
        $scope.rowItem.newNote = false;
        vm.notes.updating = false;
      });
    }

    vm.updateDefaultVisibility = function () {
      vm.notes.defaultVisibilitySetting = vm.notes.tempNoteAdd.visibility;
      var defaultRequest;
      if (vm.notes.defaultVisibilityChecked) {
        defaultRequest = vm.notes.defaultVisibilitySetting;
      }
      else {
        defaultRequest = vm.notes.defaultVisibilitySetting == "Standard" ? "Admin" : "Standard";
      }
      noteService.setNoteVisibilityDefault(defaultRequest).then(function (data) {
        $scope.noteSettings.userInfo = data;
        vm.refreshDefaultVisibilitySettings();
      });
    }

    vm.showVisibilityCheckbox = function () {
      vm.notes.showVisibilityCheckbox = true;
      vm.notes.defaultVisibilityChecked = false;
    }

    vm.hideVisibilityCheckbox = function () {
      vm.notes.showVisibilityCheckbox = false;
    }

    vm.reloadNotes = function (entity, type) {
      var idArray = [entity[$scope.noteSettings.idKey]];
      noteService.getNotes(idArray, type).then(function (data) {
        entity.notes = data;
        _.each(entity.notes, function (e) {
          e.noteDetail = noteService.processAsHtml(e.noteDetail);
        });
      });
    }

    vm.loadNotes = function (id) {
      var currentReviewNotes;
      var idArray = [id];
      noteService.getNotes(idArray, vm.notes.noteType).then(function (data) {
        currentReviewNotes = data;
      });
    }

    vm.hasError = function (el) {
      if ((el.$error.required || el.$error.maxlength ) && el.$dirty) {
        return true;
      }
    }

    vm.getName = function(note) {
      let displayName;
      if(note.firstName || note.lastName){
        displayName = `${note.firstName} ${note.lastName}`.trim()
      }
      if(displayName.length){
        displayName = `${displayName}, `;
      }
      displayName = `${displayName}${note.userName}`;
      return displayName;
    }

  }
